import {useSyncExternalStore} from 'react';

let pendingCount = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

/**
 * Ambient "is the system doing work" signal, incremented for the duration of
 * any in-flight workflow mutation. Powers HolmesJrGuide's thinking state.
 * Deliberately decoupled from carolinaWorkflowStore.ts so this can later
 * track a real fetch-backed data layer the same way.
 */
export const holmesThinkingStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getSnapshot(): boolean {
    return pendingCount > 0;
  },
  begin() {
    pendingCount += 1;
    if (pendingCount === 1) emit();
  },
  end() {
    pendingCount = Math.max(0, pendingCount - 1);
    if (pendingCount === 0) emit();
  },
  reset() {
    pendingCount = 0;
    emit();
  },
};

export function useHolmesThinking(): boolean {
  return useSyncExternalStore(holmesThinkingStore.subscribe, holmesThinkingStore.getSnapshot);
}

/** Wraps an in-flight promise so Holmes Jr. shows "thinking" for its exact duration. */
export function trackedByHolmes<T>(work: Promise<T>): Promise<T> {
  holmesThinkingStore.begin();
  return work.finally(() => holmesThinkingStore.end());
}
